export const BRAND_NAME = '21K CARE';
export const BRAND_PRODUCT = 'Customer Action & Redressal Engine';
export const BRAND_TAGLINE =
  'Customer Action & Redressal Engine';

export const BRAND_LOGO_SRC = '/brand/logo.svg';
export const BRAND_LOGO_LIGHT_SRC = '/brand/logo-light.svg';
export const BRAND_LOGO_MARK_SRC = '/brand/logo-mark.svg';
export const BRAND_LOGO_MARK_LIGHT_SRC = '/brand/logo-mark-light.svg';
export const BRAND_ICON_SRC = '/brand/icon.svg';
export const BRAND_ICON_LIGHT_SRC = '/brand/icon-light.svg';
